export default "__VITE_ASSET__b9a977b7__"